import axios from "axios";
import type { ErpId } from "src/constants/constants.ts";

export enum AppVariation {
  Erp = "erp",
  B2bGate = "b2bgate",
  B2bGateDemo = "b2bgate-demo",
  B2bGateSupplier = "b2bgate-supplier",
}

export type ClientConfig = {
  baseUrl: string;
  apiBaseUrl: string;
  appVariation: AppVariation;
  erpId: ErpId;
};

export const fetchClientConfig = async (): Promise<ClientConfig> => {
  return (
    await axios.get<ClientConfig>(import.meta.env.VITE_CONFIG_PATH, {
      params: {
        v: +new Date(),
      },
    })
  ).data;
};

export const getClientConfig = () => {
  return clientConfig;
};

export const setClientConfig = (config: ClientConfig) => {
  clientConfig = config;
};

export let clientConfig: ClientConfig | null = null;
